
import { Utils } from "../../utils";
import { BaseService, SanitizedResponse } from "../BaseService";

export interface IUploadedFile {
    file_name: string;
    relative_path: string;
    replaced_existing: boolean;
    consus_download_url: string;
    storage_download_url: string;
}

export class ConsusService extends BaseService {

    protected static instance: ConsusService;

    constructor() {
        super(process.env.REACT_APP_CONSUS_BASE_API_URL ?? "http://127.0.0.1:9305");
    }

    static getInstance() {
        if (!ConsusService.instance) ConsusService.instance = new ConsusService();
        return ConsusService.instance;
    }

    async uploadFile(folder: string, name: string, file: File): Promise<SanitizedResponse<IUploadedFile>> {
        return this.report(this.transport.post("/api/v1/storage/upload/json", {
            name,
            folder,
            encoding: "BASE64",
            mime_type: file.type,
            content: await Utils.fileToBase64(file),
        }));
    }

    async deleteFile(data: string[]): Promise<SanitizedResponse<IUploadedFile>> {
        return this.report(this.transport.delete("/api/v1/storage/multiple", { data }));
    }

}

